// This allows waiting for the execution queue to be run or a given amount of time before
// executing the next line of code, by using :
//
//    await sleep(0); // wait for the execution queue to be run
//    await sleep(1000); // wait for 1 second
//
export const sleep = async (ms = 0) => {
  return new Promise(resolve => setTimeout(resolve, ms));
};
